module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_3-2.96733700.svg";